<template>
  <div class="mt-1">
    <h3>Co-produtor</h3>
    <table class="table table-hover table-responsive-md">
      <thead>
        <tr>
          <th>Nome do Curso</th>
          <th>Criado em</th>
          <th>Aprovado?</th>
          <th>Disponivel para venda?</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <course-coop-item v-for="item in items.data" :key="item.id" :course="item" />
      </tbody>
    </table>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'
import CourseItem from './../../../components/teacher/MyCoopCourse'

export default {
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  components: {
    'course-coop-item': CourseItem
  },
  data () {
    return {
      items: {}
    }
  },
  methods: {
    load: function () {
      Axios.post('/teacher/my/co/produces/courses/list', this.user)
        .then( res => {
          this.items = res.data
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style>

</style>
